import React, { useCallback, useEffect, useRef } from "react";

import styled from "styled-components/macro";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import CheckboxSettingSection from "Signups/FamilyRegistration/Shared/CheckboxSettingSection";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

import FnrLoadingBricks from "UI/FnrLoadingBricks";
import FnrTextEditor from "UI/FnrTextEditor";

export default function IntroductionMessage() {
  const { state, dispatch } = useFamilyRegistrationContext();
  const { updateSetting, saving, error } = useUpdateSetting();
  // const [text, setText] = useState("");
  const wrapperRef = useRef();
  const text = state.textboxes.introductionMessage || "";
  // const setText = (text) =>
  //   dispatch({ type: "setIntroMessage", payload: text });
  const setText = useCallback(
    (text) => {
      dispatch({ type: "setIntroMessage", payload: text });
    },
    [dispatch]
  );

  const {
    shouldDisableFamilyRegistrationSettings,
    shouldHideNonNetworkEnabledSettings,
  } = useFamilyRegistrationAdminPermissions();

  const message =
    state?.familyRegistrationSettings?.introductionMessage?.message;

  const handleChange = (text) => {
    setText(text);
  };

  const saveOnBlur = () => {
    if (message === text) return;

    setTimeout(() => {
      // tiptap blurs when clicking the format buttons, then refocuses on the text editor
      // this only saves when it truly loses focus
      let activeEl = document.activeElement;
      let activeElIsTextEditor =
        activeEl.classList.value.includes("ProseMirror");

      if (activeElIsTextEditor) return;

      updateSetting({
        setting: "introductionMessage",
        value: text,
      });
    }, 200);
  };

  useEffect(
    function setSavedMessage() {
      if (message) setText(message);
    },
    [message, setText]
  );

  if (shouldHideNonNetworkEnabledSettings) return null;

  return (
    <CheckboxSettingSection
      setting="introductionMessage"
      label="Add an introductory message"
      disabled={shouldDisableFamilyRegistrationSettings}
    >
      <div
        ref={wrapperRef}
        style={{ maxWidth: "520px", position: "relative" }}
        onBlur={saveOnBlur}
      >
        <div data-cy="famRegIntroMsgEdit">
          <FnrTextEditor
            content={text.length === 0 && message ? message : text}
            setContent={handleChange}
            maxLength={255}
            minHeight="100px"
            autofocus={
              shouldDisableFamilyRegistrationSettings ? false : undefined
            }
          />
        </div>

        {saving ? (
          <LoadingWrapper>
            <FnrLoadingBricks show={saving} />
          </LoadingWrapper>
        ) : null}

        {error ? <ErrorMessage error={error?.error} marginLeft="0px" /> : null}
      </div>
    </CheckboxSettingSection>
  );
}

const LoadingWrapper = styled.div`
  z-index: 1000;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  background-color: hsl(0 0% 100% / 0.5);
`;
